import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgFullPageDialog } from "@intelligems/ig-theme";
import { MessageBoxWidgetDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { GlobalStylesHeader } from "@src/domains/WidgetLibrary/GlobalStylesHeader";
import { MessageBoxPreview } from "@src/domains/WidgetLibrary/MessageBox/MessageBoxPreview";
import { useWidgetSave } from "@src/domains/WidgetLibrary/useWidgetSave";
import { OfferComponentSettingsPageWrapper } from "@src/features/sharedExperience/components/offers/subpages/OfferComponentSettingsPageWrapper";
import { useViewPage } from "@src/hooks/mixpanel";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";
import { selectedWidget } from "@src/store/slices/widgets";

export const MessageBoxFullPageDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("messageBoxFullPageEditor"));
  const dialogProps = useSelector(
    getDialogPropDetails("messageBoxFullPageEditor")
  ) as
    | {
        widgetId?: string;
        variationId: string;
        widgetType: "messageBoxPopup" | "messageBoxSlideOut";
      }
    | undefined;

  const currentWidget = useSelector(selectedWidget) as MessageBoxWidgetDto;
  const { save, isSaving } = useWidgetSave(currentWidget);

  const handleClose = () => {
    dispatch(setDialog({ dialog: "messageBoxFullPageEditor", open: false }));
  };

  const handleSave = () => {
    save();
    handleClose();
  };

  useViewPage("Global Styles - Message Box Full Page Editor");
  const handleCancel = () => {
    handleClose();
  };

  const content =
    dialogProps && currentWidget ? (
      <Grid container width={"100%"} justifyContent={"center"}>
        <Grid container direction={"column"} rowSpacing={4} width={"1250px"}>
          <Grid item>
            <GlobalStylesHeader
              variantStyle={
                currentWidget.config.desktop?.variant ||
                "messageBoxPopupWidget1"
              }
              widgetType={dialogProps.widgetType}
            />
          </Grid>
          <Grid item>
            <OfferComponentSettingsPageWrapper
              variationId={dialogProps.variationId}
              widgetType={dialogProps.widgetType}
              hasQuantityButtons={false}
              hasProgressbar={false}
              hasMessageBox={true}
              offerProducts={[]}
              widgetId={dialogProps.widgetId}
              customPreview={
                <MessageBoxPreview isEdit={true} widget={currentWidget} />
              }
            />
          </Grid>
        </Grid>
      </Grid>
    ) : null;

  return (
    <IgFullPageDialog
      showDialog={isOpen}
      handleClose={handleClose}
      content={content}
      yesButtonText={isSaving ? "Saving..." : "Save Widget"}
      handleYesClick={handleSave}
      noButtonText="Cancel"
      handleNoClick={handleCancel}
      shouldNotClose={true}
      hideActions={false}
    />
  );
};
